export default [
  {
    key: 'name',
    label: 'field.projectName',
    type: 'text',
  },
  {
    key: 'isActive',
    label: 'field.status',
    type: 'radio',
    options: [
      { text: 'status.active', value: true },
      { text: 'status.inactive', value: false },
    ],
    md: 'auto',
    lg: 'auto',
  },
];
